<template>
  <div v-if="searchData" class="datarange">
    <el-popover
      title="数据范围"
      width="600"
      trigger="hover"
      :content="searchData.title.join('、')">
      <div slot="reference" class="ellipsis1">数据范围：{{searchData.title.join('、')}}
      </div>
    </el-popover>
    <i @click="onSetting" class="el-icon-setting font-20 poi"></i>
  </div>
</template>
<script>
export default {
  name: 'data-range',
  props: ['searchData'],
  methods: {
    onSetting() {
      this.$emit('onSelectDataRange')
    }
  }
};
</script>
<style scoped>
.datarange {
  border-width: 0px;
  width: 100%;
  height: 46px;
  background-color: rgba(46, 44, 138, 1);
  box-sizing: border-box;
  border: 1px solid rgba(45, 140, 240, 1);
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgb(22 23 30);
  font-size: 18px;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
}
.ellipsis1 {
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
